module.exports = __webpack_public_path__ + "img/figure-14.4bb76f78.png";